import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import './index.scss';

const CheckData = () => {
  const { t } = useTranslation();

  return (
    <div className='checkData'>
      <div className='checkData__left'>
        <img src='/assets/register-bg.png' alt='bg' />
      </div>
      <div className='checkData__right'>
        <div className='checkData__box'>
          <div className='checkData__box-img'>
            <img src='/assets/check-data.png' alt='icon' />
          </div>
          <p className='checkData__title'>{t('checkData.title')}</p>
          <p className='checkData__text'>
            {t('checkData.message')}
          </p>
          <button className='checkData__btn auth__submit'>{t('checkData.gotIt')}</button>
        </div>
      </div>
    </div>
  );
};

export default CheckData;
